import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-FKL95JS6QV", {
        page_path: location.pathname + location.search,
      });
    }

    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
}

export default AnalyticsTracker;
